import { Navigate, Route, Routes } from 'react-router';
import { PATHS } from './app/paths';
import { AuthGuard, GuestGuard } from './features/auth/routeGuards';
import { DashboardPage } from './pages/Dashboard';
import { HomePage } from './pages/Home';
import { LoginPage } from './pages/Login';

export function App() {
  return (
    <Routes>
      <Route path={PATHS.home} element={<HomePage />} />

      <Route element={<GuestGuard />}>
        <Route path={PATHS.login} element={<LoginPage />} />
      </Route>

      <Route element={<AuthGuard />}>
        <Route path={PATHS.dashboard} element={<DashboardPage />} />
      </Route>

      <Route path="*" element={<Navigate to={PATHS.home} replace />} />
    </Routes>
  );
}
